import { isEmpty } from '@/helper/lodashHelper';
import type { Settings } from '@/types/settings';

const $settings = ((): Settings | Record<string, never> => {
  const {
    authentication,
    middlewareSAPProxyURI,
    middlewareURI,
    cid,
    languages,
  } = window.settings;

  if (
    !isEmpty(authentication) ||
    middlewareURI ||
    middlewareSAPProxyURI ||
    cid ||
    !isEmpty(languages)
  ) {
    const { redirectUri } = authentication;
    const dynamicRedirectUri =
      import.meta.env.MODE === 'development'
        ? `${location.protocol}//localhost:${location.protocol === 'https:' ? '5000' : '8080'}${redirectUri}`
        : redirectUri;

    return {
      ...window.settings,
      authentication: { ...authentication, redirectUri: dynamicRedirectUri },
    };
  }

  console.warn('Missing required properties in the settings object.');
  return {};
})();

export { $settings };
